import { render, staticRenderFns } from "./SurveyNoteFormResources.vue?vue&type=template&id=8e118b96"
import script from "./SurveyNoteFormResources.vue?vue&type=script&lang=js"
export * from "./SurveyNoteFormResources.vue?vue&type=script&lang=js"
import style0 from "./SurveyNoteFormResources.vue?vue&type=style&index=0&id=8e118b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports